import React from 'react';

import './error-indicator.scss';
import icon from './error-image.png';

const ErrorIndicator = () => {
    return (
        <div className="error-indicator">
            <img src={icon} alt="Error"/>
            <span className="boom">BOOM!</span>
            <span>
                something has gone terribly wrong
            </span>
            <span>
                (but we already sent developers to fix it)
            </span>
        </div>
    )
}

export default ErrorIndicator;